var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"mobile-breakpoint":"0","items-per-page":5,"item-key":"studentCode","headers":_vm.originHeaders,"items":_vm.priceStudent,"footer-props":{
    'items-per-page-text': 'Hiển thị mỗi trang',
    'items-per-page-all-text': 'Tất cả'
  },"disable-sort":""},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.index)+"\n  ")]}},{key:"item.student",fn:function(ref){
  var item = ref.item;
return [_c('div',[_vm._v(_vm._s(item.name))]),(item.code === 'Thiếu thông tin')?_c('div',{staticClass:"text-error"},[_vm._v(_vm._s(item.code))]):_c('div',[_vm._v(_vm._s(item.code))])]}},{key:"item.dob",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.dob)+"\n  ")]}},{key:"item.gender",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.gender)+"\n  ")]}},{key:"item.class",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.class)+"\n  ")]}},{key:"item.status",fn:function(ref){
  var item = ref.item;
return [(item.status)?_c('v-chip',{staticClass:"white--text",attrs:{"small":"","color":_vm.getColor(item.status),"label":""}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(item.status))])]):_vm._e()]}},{key:"item.price",fn:function(ref){
  var item = ref.item;
return [(item.price === 'Lỗi dữ liệu')?_c('div',{staticClass:"text-error"},[_vm._v("\n      "+_vm._s(item.price)+"\n    ")]):_c('div',[_vm._v("\n      "+_vm._s(_vm.renderPrice(item))+"\n    ")])]}},{key:"item.notes",fn:function(ref){
  var item = ref.item;
return [_c('div',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(item.notes))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }